export function formatMessageToHtml(message) {
  // render basic markdown to html using regex's
  // images - ![alt text](url)
  // links - [text](url)
  // bold+italics - ***yay*** or ___yay___
  // bold - **bold** or __bold__
  // italics - *italics* or _italics_
  // bold - # Header # (optional final pound)
  // bold - ## Header

  // Markdown ![t](u) images - replace them all with img tags
  message = message.replace(/!\[([^\]]*?)\]\(([^)]*?)\)/g, (m, p1, p2) => {
    return `<img src="${p2}" alt="${p1}" />`;
  });

  // Markdown [t](u) links - replace them all with a tags
  message = message.replace(/\[([^\]]*?)\]\(([^)]*?)\)/g, (m, p1, p2) => {
    // if we don't have text value then default to url for both
    if (p1 === "") {
      p1 = p2;
    }
    return `<a href="${p2}" target="_blank">${p1}</a>`;
  });

  // Markdown <url> links - replace them with <a> tags
  message = message.replace(/<(https?:\/\/[^>]+|www\.[^>]+)>/g, (m, g1) => {
    var link = g1;
    if (!link.startsWith("http")) {
      link = "http://" + g1;
    }
    return `<a href="${link}" target="_blank">${g1}</a>`;
  });

  // markdown bold+italics -- replace with <strong><em> tags
  // markdown bold - replace with <strong> tags
  // markdown italics - replace with <em> tags
  // we run this twice to handle nested groups
  for (var i = 0; i < 2; i++) {
    message = message.replace(
      /(?<!src="[^"]*)(?<!src='[^']*)(?<!href="[^"]*)(?<!href='[^']*)(?<!target="[^"]*)(?<!target='[^']*)(\*{1,3}|_{1,3})(.*?)\1/g,
      (m, g1, g2) => {
        // the len of g1 is 1-3,
        var tag = "em";
        if (g1.length == 3) {
          tag = "em><strong";
        } else if (g1.length == 2) {
          tag = "strong";
        }

        return `<${tag}>${g2}</${tag}>`;
      },
    );
  }

  // replace markdown headers with strong tags
  message = message.replace(/^(#+) (.*?)\s?\1?$/g, (m, g1, g2) => {
    //g1=number of #s
    //g2=text
    return `<strong>${g2}</strong>`;
  });

  // convert basic links (not in button tags) to 'a' tags
  // detect http://, https://, and www.
  // handle sentence-ending urls by trimming off final dots
  // cannot be preceeded by ' or " (stops finding urls in existing a tags)
  // cannot contain </a> in it, that'd be an existing link
  message = message.replace(
    /(?<!['"\/])(?!.*<\/a>)(https?:\/\/\S+|www\.\S+)/gm,
    (m, g1) => {
      var end = "";
      // drim off any final dot
      if (g1.endsWith(".")) {
        g1 = g1.slice(0, -1);
        end = ".";
      }

      var link = g1;
      if (!link.startsWith("http")) {
        link = "http://" + g1;
      }
      return `<a href="${link}" target="_blank">${g1}</a>${end}`;
    },
  );

  // convert email address to 'a' tags with mailto: links
  // cannot be preceeded by an unclosed tag, this double-wraps 
  // existing email email links, but that's ok for browsers
  message = message.replace(
    /(?<!<[^>]*)(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim,
    '<a href="mailto:$1">$1</a>',
  );

  return message;
}
